<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-container>
            <v-row>
                <v-col lg="12" md="12" cols="12" sm="12">
                    <StockArray :dist-points="distPoints"/>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>

    import utils from '../../utilities'
    import request from '../../requests'
    import StockArray from "./StockArray";
    import {eventBus} from "../../main";

    export default {
        name: "Stock.vue",
        components: {StockArray},
        data: ()=>({
            utils,
            distPoints:[],
        }),
        methods: {

            getdistributionPointAvailability() {

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    let reqObject = {
                        cityId: null,
                        prefectureId: null
                    };
                    request.put('rest/distribution-points/selected', reqObject, this.getSelectedDistPointCallBack)
                }
                else {
                    this.$store.commit('setloginModal', true);
                }
            },

            getSelectedDistPointCallBack(response) {

                this.distPoints = JSON.parse(JSON.stringify(response.distPoints));
                console.log(this.distPoints);
                var years = this.$store.getters.years;
                var distributionPointId;
                if (this.distPoints.length > 0) {
                    distributionPointId = this.distPoints[0].id
                }

                var token = utils.getLocalStorage('token');
                var setYear = years[0].value;
                request.getdistributionPointAvailability(token,distributionPointId, setYear, this.getdistributionPointAvailabilityCallBack);
            },

            getdistributionPointAvailabilityCallBack(response) {
                this.$store.commit('setDistributionAvailability', response);
                eventBus.$emit('createSelectedVariables');
                this.$store.commit('setLoadingModal', false);
            },

        },

        created() {
            window.scrollTo(0, 0);
            this.getdistributionPointAvailability();
        }
    }
</script>

<style scoped>

</style>